import type { DisplayableError } from './isDisplayableError';
import type { WrappedError } from './isWrappedError';
import { isDisplayableError } from './isDisplayableError';
import { isWrappedError } from './isWrappedError';

export const isDisplayableWrappedError = (v: any): v is DisplayableError & WrappedError =>
  isDisplayableError(v) && isWrappedError(v);
